import { Spinner, MainLayout } from '@/components';
import { toggleLanguage } from '@/hooks';
import { GlobeIcon, LanguageText, LanguageToggleButton } from '@/styles';
import { lazyImport } from '@/utils';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { SenserPadPageRoutes } = lazyImport(() => import('@/features/sensorpad'), 'SenserPadPageRoutes');
const { TestListPageRoutes } = lazyImport(() => import('@/features/testItems'), 'TestListPageRoutes');
const { SenserPageRoutes } = lazyImport(() => import('@/features/sensor'), 'SenserPageRoutes');

export function Protected() {
  const client_id = true;

  function InnerProtected() {
    const { i18n } = useTranslation(); // 여기에 추가!
    
    if (!client_id) {
      return <Navigate to="/" state={{ redirect: location.pathname }} />;
    }
    return (
      <MainLayout>
        <LanguageToggleButton onClick={toggleLanguage}>
          <GlobeIcon>🌐</GlobeIcon>
          <LanguageText>{i18n.language === 'ko' ? 'KO' : 'EN'}</LanguageText>
        </LanguageToggleButton>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    );
  }

  const ProtectedRoutes = [
    {
      path: '/pad/*',
      element: <InnerProtected />,
      children: [
        {
          path: '*',
          element: <SenserPadPageRoutes />,
        },
      ],
    },
    {
      path: '/test/*',
      element: <InnerProtected />,
      children: [
        {
          path: '*',
          element: <TestListPageRoutes />,
        },
      ],
    },
    {
      path: '/sensor/*',
      element: <InnerProtected />,
      children: [
        {
          path: '*',
          element: <SenserPageRoutes />,
        },
      ],
    },
  ];

  return { ProtectedRoutes };
}